import { LoadingState, TransactionType } from 'globals/types';
import { ReportInstance } from 'models/report/report';
import reportLocales from 'globals/locales/report';
import { FsTransactionRowWithBarGraphDataProps } from 'ui-elements/tables/FsTransactionRowsWithBarGraph/FsTransactionRowWithBarGraph/FsTransactionRowWithBarGraph';

const { dialogTitles } = reportLocales.recurringTransactionsModal;

export const getProperRecurringTransactions = (
  type: TransactionType | undefined,
  report: ReportInstance
): {
  rows: FsTransactionRowWithBarGraphDataProps[];
  status: LoadingState;
} => {
  let recurringType;
  switch (type) {
    case TransactionType.TOP_EXPENDITURE:
      recurringType = report.topRecurringExpenditures;
      break;
    case TransactionType.TOP_INCOME:
      recurringType = report.topRecurringIncomes;
      break;
    case TransactionType.EXPENDITURE:
      recurringType = report.recurringExpenditures;
      break;
    case TransactionType.INCOME:
      recurringType = report.recurringIncomes;
      break;
    default:
      recurringType = {
        rows: (): FsTransactionRowWithBarGraphDataProps[] => [],
        status: LoadingState.FAILED,
      };
      break;
  }
  const { rows, status } = recurringType;
  return {
    rows: rows(),
    status,
  };
};

export const getDialogTitle = (type: TransactionType | undefined): string => {
  switch (type) {
    case TransactionType.TOP_EXPENDITURE:
      return dialogTitles.topExpenditure;
    case TransactionType.TOP_INCOME:
      return dialogTitles.topIncome;
    case TransactionType.EXPENDITURE:
      return dialogTitles.expenditure;
    case TransactionType.INCOME:
      return dialogTitles.income;
    default:
      return '';
  }
};
